import type { AllHTMLAttributes, ReactNode } from "react";

import styles from "./tabs-body.module.css";

export type TabsBodyProps = {
  children: ReactNode;
} & AllHTMLAttributes<HTMLDivElement>;

export function TabsBody({ children, ...props }: TabsBodyProps) {
  return (
    <div {...props} className={styles.Container}>
      {children}
    </div>
  );
}
